/* import __COLOCATED_TEMPLATE__ from './list-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import type ContentImportService from 'embercom/services/content-import-service';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class ListEmptyState extends Component {
  @service declare contentImportService: ContentImportService;
  @service declare router: RouterService;
  @service declare appService: AppService;

  get contentReviewSummary() {
    return this.contentImportService.aiContentReviewSummary;
  }

  get hasApprovedSuggestions() {
    if (!this.contentReviewSummary) {
      return false;
    }
    return this.contentReviewSummary.approved > 0;
  }

  @action
  onExploreTopics() {
    let route = this.appService.app.canUseStandalone
      ? 'apps.app.standalone.topics-explorer'
      : 'apps.app.automation.fin-ai-agent.analyze.topics-explorer';
    this.router.transitionTo(route);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::ListEmptyState': typeof ListEmptyState;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/list-empty-state': typeof ListEmptyState;
  }
}
